import { Component, OnInit, Output, EventEmitter, Input, HostListener, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Observable, Subject, Subscription, throwError } from 'rxjs';
import { catchError, debounceTime } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
import { Select2Directive } from "@teem/directives/select2.directive";
import { messages as i18n } from '@teem/constants/messages';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { customer as CustomerApi } from '@teem/core/constants/api';
import { OrderService } from '@teem/app/core/services/order.service';
import { LoaderService } from '@teem/app/core/services/loader.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { queryString } from '@teem/app/utils/functions';
declare var $;

@Component({
  selector: 'order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderDetailComponent implements OnInit {
	// @Input() orders;
	// @Input() paginator;
	// @Output() onPageChange: EventEmitter<any> = new EventEmitter();
  // @Output() perPageItems: EventEmitter<any> = new EventEmitter();
  // @Output() sortRequested = new EventEmitter<{ column: string; direction: string }>();
  @Input() tableSection;
	@Output() onViewOrder: EventEmitter<any> = new EventEmitter();
  @Output() orderAction: EventEmitter<any> = new EventEmitter();
  @Output() updateOrderStatuses: EventEmitter<any> = new EventEmitter();

  itemsPerPageOptions = [5, 10, 20, 50, 100];
  sortColumn: string | null = null;
  sortDirection: 'asc' | 'desc' = 'asc';
  searchSubscription: Subscription;
    search: Subject<string> = new Subject<string>();
    searchText: string;
  
    orders: any[] = [];
    params: any = {};
    paginator: any = {};

  constructor(
    private modalService: NgbModal,
    private elem: ElementRef,
    private orderService: OrderService,
    private loaderService: LoaderService,
    private clipboard: Clipboard,
    private cdr: ChangeDetectorRef,
    private httpClient: HttpClient
  ) { }

  ngOnInit(): void {
    this.paginator = {
      id: this.tableSection+'-table-paginator',
      currentPage: 1,
      itemsPerPage: 5, //environment.pageSize,
      totalItems: 0
    }
		this.searchSubscription = this.search.asObservable().pipe(debounceTime(300)).subscribe(data => {
			if (this.searchText != data) {
			  this.searchText = data;
	  
			  if (this.searchText.length == 0 || this.searchText.length >= 3) {
				this.getPage(1,false);
			  }
			}
		})
		this.getPage(1);
	}

  // Emit event to parent to fetch orders with sorting
  sortData(column: string) {
    // Toggle sort direction if the same column is clicked
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // New column clicked, reset to ascending
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    // Emit event to the parent component to call the API
    // this.sortRequested.emit({ column: column, direction: this.sortDirection });
    this.fetchOrders(column,this.sortDirection);
  }

  toggleOrderDetails(number:any) {
    $('#catalogue-details-'+number).slideToggle();
  }

  onChangeItemsPerPage(event: Event, api: any) {
    console.log('child')
    const selectElement = event.target as HTMLSelectElement;
    this.onChangePerPageItems({ limit: +selectElement.value });
  }

  public getPage(page: number, loading: boolean = true, additionalParams: any = null) {
  
      if (loading) {
        this.loaderService.startLoading();
      }
  
      let params: any = {
        page: page,
        limit: this.paginator.itemsPerPage
      }
  
  
  
      if (additionalParams) {
        Object.assign(params, additionalParams);
      }
      if (this.params) {
        Object.assign(params, this.params);
      }
      if(this.tableSection){
        Object.assign(params, {
          'section':this.tableSection
        });
      }
  
      this.getData(params).subscribe(
        (r) => {
          if (r.meta) {
            this.paginator.totalItems = r.meta.total;
            this.paginator.itemsPerPage = r.meta.per_page;
            this.paginator.currentPage = r.meta.current_page;
            this.paginator.from = r.meta.from;
            this.paginator.to = r.meta.to;
            this.orders = r.data;
  
            this.cdr.detectChanges(); // manually tell Angular to update
  
            setTimeout(() => {
              $('#tab-links-select[nice-select]').niceSelect('update');
            }, 10);
          }
  
          this.loaderService.stopLoading();
        }, (err) => {
          this.loaderService.stopLoading()
        }
      )
    }
  
    getData(params): Observable<any> {
      // let url = OrderApi.endPoint;
      let url = CustomerApi.orders;
  
      if (url.indexOf('?') == -1)
        url += ('?' + queryString(params));
      else
        url += ('&' + queryString(params));
  
      return this.httpClient.get(`${url}`).pipe(
        catchError((err: any) => {
          this.loaderService.stopLoading()
          return throwError(err);
        })
      )
    }
  
    onChangePerPageItems(page: any) {
      if (page?.limit) {
        this.paginator.itemsPerPage = page?.limit;
        this.params.limit = page?.limit;
        this.getPage(1,false, this.params);
      }
    }
  
    fetchOrders(sortColumn?: string, sortDirection?: string) {
      this.params.order_by = sortColumn;
      this.params.direction = sortDirection;
      this.getPage(1, true, this.params)
    }

    backToStore(): void {
      // window.history.back();
      window.location.href = 'https://app.teem-app.com/storefronts';
    }
  
    get getOrders() {
      return this.orders.filter(o => o.status !== 'complete');
    }
  
    get trackOrders() {
      return this.orders.filter(o => o.status !== 'complete');
    }
  
    get completedOrders() {
      return this.orders.filter(o => o.status === 'complete');
    }
}
